import { request } from './index'
import type { ApiResponse } from './index'

/**
 * 推广API接口
 */

// 分享链接数据类型
export interface ShareLinkData {
  shareUrl: string
  shareCode: string
  shareText: string
  rewardAmount: string
}

// 推广统计数据类型
export interface PromotionOverviewData {
  totalVisits: number
  totalRegistrations: number
  totalRewards: number
  totalRewardAmount: number
  conversionRate: number
}

// 推广统计详情类型
export interface PromotionStatistics {
  statDate: string
  totalShares: number
  totalVisits: number
  totalNewUsers: number
  totalRegistrations: number
  totalRewards: number
  totalRewardAmount: number
  conversionRate: number
}

// 生成分享链接
export function generateShareLink(userId: number) {
  return request.get<ShareLinkData>('/promotion/share-link', {
    params: { userId }
  })
}

// 记录推广访问
export function recordVisit(data: {
  shareCode: string
  visitorDevice?: string
  referrerUrl?: string
  utmSource?: string
  utmMedium?: string
  utmCampaign?: string
}) {
  return request.post<void>('/promotion/visit', data)
}

// 获取用户推广统计
export function getUserStatistics(params: {
  userId: number
  startDate?: string
  endDate?: string
}) {
  return request.get<any>('/promotion/statistics', { params })
}

// 获取用户推广总览
export function getUserOverview(userId: number) {
  return request.get<PromotionOverviewData>('/promotion/overview', {
    params: { userId }
  })
}

// ==================== 管理后台接口 ====================

// 获取系统推广统计
export function getSystemStatistics(params: {
  startDate?: string
  endDate?: string
}) {
  return request.get<any>('/admin/promotion/statistics', { params })
}

// 手动更新统计数据
export function updateStatistics(date?: string) {
  return request.post<any>('/admin/promotion/statistics/update', null, {
    params: { date }
  })
}

// ==================== 推广配置管理接口 ====================

// 获取所有推广规则
export function getPromotionRules() {
  return request.get<any>('/admin/promotion/config/rules')
}

// 获取启用的推广规则
export function getActiveRules() {
  return request.get<any>('/admin/promotion/config/rules/active')
}

// 创建推广规则
export function createPromotionRule(data: any) {
  return request.post<any>('/admin/promotion/config/rules', data)
}

// 更新推广规则
export function updatePromotionRule(id: number, data: any) {
  return request.put<any>(`/admin/promotion/config/rules/${id}`, data)
}

// 删除推广规则
export function deletePromotionRule(id: number) {
  return request.delete<any>(`/admin/promotion/config/rules/${id}`)
}

// 切换规则状态
export function togglePromotionRuleStatus(id: number) {
  return request.put<any>(`/admin/promotion/config/rules/${id}/toggle`)
}

// 获取分享设置
export function getShareSettings() {
  return request.get<any>('/admin/promotion/config/settings/share')
}

// 保存分享设置
export function saveShareSettings(data: any) {
  return request.post<any>('/admin/promotion/config/settings/share', data)
}

// 获取社交平台设置
export function getSocialSettings() {
  return request.get<any>('/admin/promotion/config/settings/social')
}

// 保存社交平台设置
export function saveSocialSettings(data: any) {
  return request.post<any>('/admin/promotion/config/settings/social', data)
}

// 获取奖励设置
export function getRewardSettings() {
  return request.get<any>('/admin/promotion/config/settings/reward')
}

// 保存奖励设置
export function saveRewardSettings(data: any) {
  return request.post<any>('/admin/promotion/config/settings/reward', data)
}
